"use strict";

exports.__esModule = true;
exports.default = void 0;

var _scrollspy = _interopRequireDefault(require("./scrollspy"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var directives = {
  BScrollspy: _scrollspy.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    directives: directives
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/scrollspy/index.js
// module id = 573
// module chunks = 7